/* eslint-disable max-len */
import * as questionIds from "../../questions/questionIds";

export const confidentialityQuestions = [
    {
        id: questionIds.PrivacyStatementConfirmation,
        questionText: "I can confirm that I have been provided with access to the <a href=\"https://tphealth.co.uk/privacy-statement\" target=\"_blank\" rel=\"noopener noreferrer\">Privacy Statement</a> which clearly explains in detail how, where and when my personal and health data will be processed",
    },
    {
        id: questionIds.TeamPreventProcessPersonalInfoConfirmation,
        questionText: "In ticking this box, I understand that Optima Health will process my personal and Health related information for Occupational Health Purposes",
    },
    {
        id: questionIds.InformationHeldSecurelyConfirmation,
        questionText: "I understand that my information will be held securely and if I wish to gain access to my medical information I can do so by requesting access in writing to Optima Health",
    },
    {
        id: questionIds.FitnessToWorkProvidedToEmployerConfirmation,
        questionText: "I understand that information on my fitness to work will be provided to my employer",
    },
];
